import * as React from 'react'
import { NextRouter, useRouter } from 'next/router'
import { useImmer } from 'use-immer'
import { Draft } from 'immer'

interface State {
  readonly initializing: boolean
  readonly pageMode: PageMode
  readonly withPassword: boolean
}

type SetState = (f: (draft: Draft<State>) => void | State) => void

export enum PageMode {
  SignUp = 'signUp',
  SignIn = 'signIn',
}

export interface AuthPageState extends State {
  readonly setState: SetState
  readonly setWithPassword: (value: boolean) => void
}

export function useAuthState(): AuthPageState {
  const router = useRouter()
  const [state, setState] = useImmer<State>({ initializing: true, pageMode: getPageMode(router), withPassword: false })
  const setWithPassword = (value: boolean) => {
    try {
      sessionStorage.setItem('auth.withPassword', value.toString())
    } catch {
      // NOTE: Do nothing. Some browsers does not support sessionStorage.setItem()
    }
    setState(draft => {
      draft.withPassword = value
    })
  }

  React.useEffect(() => {
    const item = sessionStorage.getItem('auth.withPassword')
    setState(draft => {
      draft.initializing = false
      draft.withPassword = item === 'true'
      draft.pageMode = getPageMode(router)
    })
  })

  return { ...state, setState, setWithPassword }
}

function getPageMode(router: NextRouter) {
  const { page } = router.query
  switch (page) {
    case 'sign-up':
      return PageMode.SignUp
    case 'sign-in':
      return PageMode.SignIn
    default:
      throw new Error('Invalid page is specified')
  }
}
